export const useRequestSoundsStore = defineStore('requestSounds', {
  state: () => {
    return {
      // The switch the interpreter has inside an open request. It lives for one
      // request only — closing or leaving it turns the sounds back on — so it is
      // never persisted anywhere.
      enabledInRequest: true,
    };
  },

  actions: {
    resetState() {
      this.enabledInRequest = true;
    },
  },

  getters: {
    // The preference saved on the user (Nastavení, karta Ostatní).
    isMutedInSettings() {
      return useAuthStore().user?.play_sound_notifications === false;
    },

    // Ordinary request sounds need both gates open, so the switch inside the
    // request can only mute. The SOS sound bypasses this and is never silenced.
    isPlaybackAllowed(state) {
      return !this.isMutedInSettings && state.enabledInRequest;
    },
  },
});
